import {RequestFormType} from "../const/const"
import RequestFormSettings from "./settings/settings"
import {ModelInterface} from "../../../../core/data-structures/collection"
import {RequestFormConfig} from "../form-config"
import {loadFormMissingData} from "./functions/load-form-missing-data"
import CustomFieldsManager from "../../../../core/gd/manager/custom-fields-manager"
import ApiRequestForm from "../../../../core/gd/api/request-form"
import ModelProxy from "../../../../core/model2/model-proxy"
import openFormAction from "../actions/open-form"
import editFormAction from "../actions/edit-form"
import {CustomFieldScope} from "../../../../core/gd/const/fields/custom-fields-v1-const";
import {SessionCustomField} from "../../../../core/gd-model/custom-field/gd-custom-field";
import CUSTOM_FIELDS_V1 from "../../../../core/gd/const/fields/custom-fields-v1";

const debug = false
// const debug = "RequestForm"

export default class RequestForm implements ModelInterface {

    id                  : ID            // request form ID
    companyId           : ID            // the company to which the form belongs
    type                : RequestFormType
    // access              : any        // pust' budet dumau ponadobitsya
    // sharedViewId        : ID         // shared view id used with public (forms) only
    publicKey           : string        // sharedView.public_key shared.goodday.work/PUBLIC_KEY

    sortPosition        : number        // vopros - kak mi sortiruem forms / request separately pofig esli odinkaovie dlyaraznih types ?


    // Task creation
    _projectId          : ID            // project where we create new tasks
    taskTypeId          : ID            // type of task that will be created when the form is submitted (REQUIRED - first project task type by default)
    assignToUserId      : ID | null     // the user task will be assigned to when the form is submitted

    name                : string        // Sytem name we display in management interface
    description?        : string        // System description we use in managment interafece *used for request only?

    settings            : RequestFormSettings

    // History - poka pod voprosom
    // momentCreated?      : Moment
    // createdByUserId?    : ID
    // lastUpdatedByUserId?: ID
    // lastUpdatedMoment?  : Moment

    isDeleted           : boolean
    submissionsCount    : number

    updatedFields       : Set<string>

    constructor(data:any, options={}) {

        this.id                 = _.get(data, 'id', null)
        this.companyId          = _.get(data, 'companyId', null)
        this.type               = _.get(data, 'type', RequestFormType.REQUEST)
        this.publicKey          = _.get(data, 'publicKey', null)
        this.sortPosition       = _.get(data, 'sortPosition', 0)

        this._projectId         = _.get(data, 'projectId', null)
        this.taskTypeId         = _.get(data, 'taskTypeId', null)
        this.assignToUserId     = _.get(data, 'assignToUserId', null)

        this.name               = _.get(data, 'name', null)
        this.description        = _.get(data, 'description', undefined)

        this.settings           = new RequestFormSettings(this.type, _.get(data, 'settings', null))

        this.isDeleted          = _.get(data, 'isDeleted', false)
        this.submissionsCount   = _.get(data, 'submissionsCount', 0)

        this.updatedFields      = new Set()

        const useProxy = _.get(options, 'useProxy', true)
        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    static async initFromConfig(config:RequestFormConfig):Promise<any> {
        await loadFormMissingData(config)

        return new RequestForm(config)
    }

    applyDelta(data:any) {

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'type') return

            switch (key) {
                case 'settings':
                    this.settings = new RequestFormSettings(this.type, value)
                    isChanged = true
                    break

                // case 'crmIntegration':
                //     this.crmIntegration = new RequestFormCrmIntegration(value)
                //     isChanged = true
                //     break

                default:
                    // @ts-ignore
                    this[key] = value
                    isChanged = true
            }

            debug && console.log(debug, "applyDelta key=", key, "value=", value)

            isChanged = true
        })

        return isChanged
    }

    get isRequest() {
        return this.type === RequestFormType.REQUEST
    }

    get isForm() {
        return this.type === RequestFormType.FORM
    }

    get publicURL() {
        return gdConfig.sharedViewPath + this.publicKey
    }

    get embedCode() {
        return '<iframe src="'+this.publicURL+'"/>'
    }

    get availableTaskTypesIds() {
        // based on project
        const taskTypesIds = gd.session.projects.get(this._projectId)!.getInheritedTaskTypes()
        return taskTypesIds
    }

    get availableAssignToUsersIds() {
        // based on project
        const projectUsers = gd.session.projectUsers.filterByProject(this._projectId)
        return _.map(projectUsers.models, pu=>pu.user.id)
    }

    getDefaultTaskType() {
        return this.availableTaskTypesIds[0]
    }

    get availableCustomFieldsIds():ID[] {
        return _(CustomFieldsManager.getProjectTaskListCustomFields(
            [this.taskTypeId],
            this._projectId,
            [CustomFieldScope.TASK]))
            .filter((customField:SessionCustomField) => {
                return customField.type !== CUSTOM_FIELDS_V1.type.FORMULA
            })
            .map(customField => customField.id)
            .value()
    }

    get projectId() {
        return this._projectId
    }

    set projectId(value) {
        this._projectId = value
        // if current task type is not among available then change it to first from available
        const taskTypesIds = this.availableTaskTypesIds
        if (!taskTypesIds.includes(this.taskTypeId)) {
            this.taskTypeId = taskTypesIds[0]
        }

        // if current assigned to user is not among available then change it to first from available
        const userIds = this.availableAssignToUsersIds
        if (!userIds.includes(this.assignToUserId)) {
            this.assignToUserId = null
        }
    }

    open() {
        debug && console.log(debug, 'open', this.type, this)
        openFormAction(this)
    }

    edit() {
        debug && console.log(debug, 'edit', this.type, this)
        editFormAction(this.id)
    }

    // Data management
    async save() {
        debug && console.log(debug, 'save', this.updatedFields, this.settings.updatedFields)

        const params:any = {}

        this.updatedFields.forEach((fieldName:string) => {
            // @ts-ignore
            params[fieldName] = this[fieldName]
        })
        this.updatedFields.clear()

        // check if settings is modified
        if (this.settings.updatedFields.size > 0) {
            params.settings = this.settings.toJSON()
            this.settings.updatedFields.clear()
        }

        if (params && _.size(params)>0) return await ApiRequestForm.updateForm(this.id, params)

        return true
    }

    delete() {
        // make remove request
    }

    // for form duplication
    clone():RequestForm {
        return new RequestForm(this.toJSON())
    }

    toJSON() {
        let res: JSONObject = {
            id                  : this.id,
            companyId           : this.companyId,
            type                : this.type,
            sortPosition        : this.sortPosition,
            projectId           : this._projectId,
            taskTypeId          : this.taskTypeId,
            assignToUserId      : this.assignToUserId,
            name                : this.name,
            description         : this.description || null,

            settings            : this.settings.toJSON()
        }
        return res
    }

    toOption():Option {
        return {
            label       : this.name,
            value       : this.id,
            icon        : 'i5-request'
        }
    }
}
